import {API_REQUEST} from "Request/API";

export const SOURCE_ID_MAP: { [key: string]: number | null } = {
  balance: 2,
  tbc: 1,
  bog: 3,
  savedcard: null,
}

export const handleCardRequest = (
    members: any,
    checkboxes: any,
    setIsLoadingSave: any,
    toast: any,
    paymentMethod: any,
    promoCode?: string
) => {

  const body = {
    subscription: checkboxes.subscriptionEnabled,
    saveCard: checkboxes?.rememberCard,
    cardId: paymentMethod?.method == "savedcard" ? paymentMethod?.card : null,
    sourceId: SOURCE_ID_MAP[paymentMethod?.method],
    addUserGroupDTOS: members.members?.filter((e: any) => !e.isAproved),
    promoCode: promoCode
  };


  API_REQUEST(
      "POST",
      "medical/buy-medical-card",
      body,
      undefined,
      "fullresponse"
  )
      .then((response) => {
        if (
            (paymentMethod?.method == "savedcard" || paymentMethod?.method == "balance") &&
            response?.data?.redirectUrl == null
        ) {
          window.location.href = `/user/order?orderId=${response?.data?.orderId}`;
          setIsLoadingSave && setIsLoadingSave(false);
          return;
        }

        setIsLoadingSave && setIsLoadingSave(false);
        window.location.href = response?.data?.redirectUrl;
      })
      .catch((e) => {
        setIsLoadingSave && setIsLoadingSave(false);
        if (e.response.data.errorCode === 1011) {
          toast("დაელოდეთ, თქვენი მოთხოვნა მუშავდება", {
            type: "error",
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            draggable: true,
            theme: "light",
          });

        } else {
          toast("ბარათის ყიდვისას მოხდა შეცდომა", {
            type: "error",
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            draggable: true,
            theme: "light",
          });
        }
      });
};
